import React, { useContext, useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { SlideDown } from "react-slidedown";
import { Scrollbar } from "react-scrollbars-custom";
import Dropdown from "components/Dropdown";
import {
  flow,
  map,
  uniq,
  filter,
  includes,
  flatten,
  chunk,
  split,
  each,
  reduce,
} from "lodash/fp";

import Tag from "components/Tag";

import StoreContext from "context/Store";

import { getCollections, getOptionGroups, translateSize } from "utils/product";

import { SIZE_LOCALES } from "constants/product";
import {
  Accordion,
  AccordionItem,
  AccordionLabel,
  AccordionContent,
  AccordionContentInner,
  DropdownWrapper,
} from "./Menu.styles";

export const DesignerMenu = (props) => {
  if (!props.designers.length) return null;

  const open = props.openItem === "designers";

  return (
    <AccordionItem>
      <AccordionLabel onClick={() => props.onItemClick("designers")}>
        <span>Designers</span>
        <i className={`icon-chevron-${open ? "up" : "down"}`}></i>
      </AccordionLabel>

      <AccordionContent>
        {open && (
          <AccordionContentInner>
            <Scrollbar style={{ height: props.scrollHeight }}>
              <div ref={props.collectionScrollContentRef}>
                {props.designers.map((c, i) => {
                  const f = `collection:${c.handle}:${c.title}`;
                  return (
                    <Tag
                      key={i}
                      text={c.title}
                      active={props.filters.includes(f)}
                      width="100%"
                      onClick={() => props.toggleFilter(f)}
                    />
                  );
                })}
              </div>
            </Scrollbar>
          </AccordionContentInner>
        )}
      </AccordionContent>
    </AccordionItem>
  );
};
